import React from "react";
import {
	Container,
	CustomButton,
	FriendActivity,
	FriendImage,
	FriendInfo,
	FriendName,
	FriendText
} from "./styles";
import type { FriendShopOffer, FriendShopUser } from "interfaces/friend-shop";
import { useEnvContext, useWebStoreContext } from "contexts";
import { useImagePath } from "hooks/useImagePath";
import { friendCenterAssets } from "assets/cdn";
import moment from "moment";
import { getProfileImageByUserId } from "helpers/getProfileImageByUserId";
import { usePopUpsV2 } from "components/PopUpManagerV2/hooks/usePopUpsV2";
import { useGoogleAnalyticsContext } from "contexts";

interface Props {
	data: FriendShopUser;
	selectedGift?: FriendShopOffer;
}

const FriendItem = ({ data, selectedGift }: Props) => {
	const { nowTime } = useWebStoreContext();
	const { backendUri } = useEnvContext();
	const { getImage } = useImagePath("cdn");
	const profileImage = getImage(friendCenterAssets.common.profileMock);
	const referenceTime = nowTime ?? moment();
	const lastActiveTime = moment(data.lastActiveDate);
	const avatarCacheKey = data?.lastActiveDate;
	const friendImageUrl = getProfileImageByUserId({
		backendUri,
		pictureId: data?.pictureId,
		userId: data?.userId,
		cacheKey: avatarCacheKey
	});
	const { open } = usePopUpsV2();
	const { reportPlaygamiEvent } = useGoogleAnalyticsContext();
	const onClick = () => {
		reportPlaygamiEvent("tp.web_frontend", {
			event_name: "friend_list_click",
			event_type: "friend_list",
			action: "friend_select",
			source: "friend_shop",
			type: data.userId
		});
		open({
			variant: "friend-shop-confirm-popup",
			id: "friend-shop-confirm-popup",
			replaceIfExists: true,
			payload: {
				selectedUser: data,
				selectedGift
			}
		});
	};
	const idleText = (() => {
		if (!lastActiveTime.isValid()) {
			return "Idle 0 minutes";
		}

		const diffInMinutes = Math.max(
			0,
			referenceTime.diff(lastActiveTime, "minutes")
		);
		const maxIdleThresholdMinutes = 30 * 24 * 60; // 30 days in minutes

		const relativeTime = lastActiveTime.from(referenceTime, true);
		if (lastActiveTime.isAfter(referenceTime)) {
			return `Active in ${relativeTime}`;
		}

		if (diffInMinutes >= maxIdleThresholdMinutes) {
			return "Idle 30+ days";
		}

		return `Idle ${relativeTime}`;
	})();

	return (
		<Container>
			<FriendInfo>
				<FriendImage
					style={{
						backgroundImage: `url(${friendImageUrl || profileImage})`
					}}
				/>
				<FriendText>
					<FriendName title={data?.playerName}> {data?.playerName} </FriendName>
					<FriendActivity>{idleText}</FriendActivity>
				</FriendText>
			</FriendInfo>
			<CustomButton onClick={onClick}>Send Gift</CustomButton>
		</Container>
	);
};

export default FriendItem;
